module.exports = __webpack_public_path__ + "img/usuarios.c5c1d2d3.svg";